import React from "react";

import { colorsV2 } from "../../styles/colors";

export default (props) => {
  return (
    <div
      style={{
        margin: 20,
        width: 300,
        height: 150,
        borderRadius: 10,
        border: "solid 2px",
        borderColor:
          props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
            ? props.whiteLabelSettings.primaryColor
            : colorsV2.bunting,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "1px 3px 1px #9E9E9E",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          margin: 0,
          padding: 0,
          color:
            props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
              ? props.whiteLabelSettings.primaryColor
              : colorsV2.primary,
        }}
      >
        {props.title}
      </h2>
      <p
        style={{
          textAlign: "center",
          margin: 0,
          padding: 0,
          fontSize: 60,
          color:
            props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
              ? props.whiteLabelSettings.accentColor
              : colorsV2.lightningYellow,
          fontFamily: "Poppins-SemiBold",
        }}
      >
        {props.score && parseInt(props.score, 10)}
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/NPSScore.js